<template>
  <avue-form ref="form" v-model="form" :option="option" v-loading="pageLoading">
    <template slot="form1">
      <el-form
        ref="form1"
        :model="form1"
        :rules="form1Rules"
        label-width="0px"
        style="min-height: 120px"
      >
        <!-- 预收指定期数费用 -->
        <el-row gutter="10" v-if="form.sceneType == 1">
          <el-col span="2"> 预收 </el-col>
          <el-col span="6">
            <el-form-item prop="preNum">
              <el-input v-model="form1.preNum" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col span="3"> 个月的 </el-col>
          <el-col span="6">
            <el-form-item prop="subjectId">
              <el-select v-model="form1.subjectId" placeholder="请选择费用类型" :disabled="true">
                <el-option
                  v-for="(item, index) in subjectList"
                  :key="index"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row gutter="10" v-if="form.sceneType == 1">
          <!-- <el-col span="3"> 预收按 </el-col>
          <el-col span="6">
            <el-form-item label="">
              <el-select v-model="form1.monthType" placeholder="请选择计算方式" :disabled="true">
                <el-option label="自然月" value="1"></el-option>
                <el-option label="账单月" value="2"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col span="2"> 计算 </el-col> -->
          <el-col span="6">
            <el-form-item label="">
              <el-select v-model="form1.includeFlag" placeholder="请选择是否包含" :disabled="true">
                <el-option label="包含" value="1"></el-option>
                <el-option label="不含" value="2"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col span="3"> 当前月 </el-col>
        </el-row>
        <!-- 交清指定时间内费用 -->
        <el-row gutter="10" v-if="form.sceneType == 2">
          <el-col span="2"> 交清 </el-col>
          <el-col span="16">
            <el-form-item label="" prop="timeRange">
              <el-date-picker
                v-model="form1.timeRange"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                format="yyyy-MM-dd"
                :clearable="false"
                :disabled="true"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col span="1"> 的 </el-col>
          <el-col span="5">
            <el-form-item prop="subjectId">
              <el-select v-model="form1.subjectId" placeholder="请选择费用类型" :disabled="true">
                <el-option
                  v-for="(item, index) in subjectList"
                  :key="index"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- 交满指定金额费用 -->
        <el-row gutter="10" v-if="form.sceneType == 3">
          <el-col span="2"> 交满 </el-col>
          <el-col span="6">
            <el-form-item prop="satisfyAmount">
              <el-input v-model="form1.satisfyAmount" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col span="2"> 元的 </el-col>
          <el-col span="6">
            <el-form-item prop="subjectId">
              <el-select v-model="form1.subjectId" placeholder="请选择费用类型" :disabled="true">
                <el-option
                  v-for="(item, index) in subjectList"
                  :key="index"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </template>
    <template slot="form2">
      <el-form
        ref="form2"
        :model="form2"
        :rules="form2Rules"
        label-width="0px"
        style="min-height: 60px"
      >
        <el-row gutter="10" v-if="form.derateType == 1">
          <el-col span="2"> 减免 </el-col>
          <el-col span="6">
            <el-form-item prop="derateNum">
              <el-input v-model="form2.derateNum" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col span="3"> 个月的 </el-col>
          <!-- <el-col span="6">
            <el-form-item prop="subjectId">
              <el-select v-model="form2.subjectId" placeholder="请选择费用类型" :disabled="true">
                <el-option
                  v-for="(item, index) in subjectList"
                  :key="index"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col> -->
        </el-row>
        <el-row gutter="10" v-if="form.derateType == 2">
          <el-col span="4"> 总额减少 </el-col>
          <el-col span="6">
            <el-form-item prop="satisfyAmount">
              <el-input v-model="form2.satisfyAmount" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col span="1"> 元 </el-col>
        </el-row>
        <el-row gutter="10" v-if="form.derateType == 3">
          <el-col span="4"> 赠送礼品 </el-col>
          <el-col span="6">
            <el-form-item prop="girtNum">
              <el-input v-model="form2.girtNum" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col span="1"> 份 </el-col>
        </el-row>
      </el-form>
    </template>
    <template slot="menuForm">
      <el-button @click="quitDialog">退出</el-button>
    </template>
  </avue-form>
</template>

<script>
import dayjs from 'dayjs';
import { getTreeChildrenNode2, getDetail } from '@/api/v4ward/fee/preferentialrules';
export default {
  props: {
    communityList: {
      default: [],
    },
    subjectList: {
      default: [],
    },
    viewId: {
      default: '',
    },
  },
  data() {
    return {
      pageLoading: false,
      option: {},
      buildingList: [],
      form1: {
        preNum: '',
        subjectId: '',
        monthType: '1',
        includeFlag: '2',
        timeRange: [],
        satisfyAmount: '',
      },
      form1Rules: {
        preNum: [
          {
            validator(rules, value, cb) {
              if (!value) {
                cb(new Error('请输入期数'));
              } else {
                if (!/^[1-9]\d{0,4}$/.test(value)) {
                  cb(new Error('期数为 1 至 5 位的正整数'));
                } else {
                  cb();
                }
              }
            },
            trigger: 'change',
          },
        ],
        timeRange: [
          {
            validator(rules, value, cb) {
              console.log('value==>', value);
              if (!value || value.length < 1) {
                cb(new Error('请选择日期范围'));
              } else {
                cb();
              }
            },
          },
        ],
        satisfyAmount: [
          {
            validator(rules, value, cb) {
              if (!value) {
                cb(new Error('请输入金额'));
              } else {
                if (!/^[1-9]\d{0,6}(\.\d{1,2})?$/.test(value)) {
                  cb(new Error('金额格式错误或者金额过大'));
                } else {
                  cb();
                }
              }
            },
          },
        ],
      },
      form2: {
        derateNum: '',
        subjectId: '',
        satisfyAmount: '',
        girtNum: '',
      },
      form2Rules: {
        derateNum: [
          { required: true, message: '请输入减免期数' },
          { pattern: /^[1-9]\d{0,3}$/, message: '请输入 1 到 4 位的整数', trigger: 'change' },
        ],
        satisfyAmount: [
          { required: true, message: '请输入金额' },
          {
            pattern: /^[1-9]\d{0,6}(\.\d{1,2})?$/,
            message: '金额格式错误或者金额过大',
            trigger: 'change',
          },
        ],
        girtNum: [
          { required: true, message: '请输入礼物数量' },
          { pattern: /^[1-9]\d{0,3}$/, message: '请输入 1 到 4 位的整数', trigger: 'change' },
        ],
      },
      form: {
        communityId: '',
        name: '',
        propertyIdsArray: [],
        sceneType: 1,
        derateType: 1,
        useTime: dayjs().format('YYYY-MM-DD'),
        stopTime: dayjs().add(1, 'day').format('YYYY-MM-DD'),
        description: '',
      },
    };
  },
  methods: {
    genOption() {
      let self = this;
      this.option = {
        submitBtn: false,
        emptyBtn: false,
        column: [
          {
            label: '小区名称',
            prop: 'communityId',
            type: 'select',
            clearable: false,
            span: 12,
            dicData: this.communityList,
            props: {
              label: 'title',
              value: 'id',
            },
            disabled: true,
            rules: [
              {
                required: true,
                message: '请选择小区名称',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '减免名称',
            prop: 'name',
            disabled: true,
            span: 12,
            rules: [
              { required: true, message: '请输入减免名称', trigger: 'blur' },
              { min: 1, max: 100, message: '输入长度在 1 到 100 之间' },
            ],
          },
          {
            label: '减免范围',
            prop: 'propertyIdsArray',
            type: 'select',
            multiple: true,
            filterable: true,
            clearable: false,
            disabled: true,
            dicData: [],
            props: { label: 'title', value: 'id' },
            span: 12,
            // rules: [
            //   {
            //     required: true,
            //     validator(rule, value, cb) {
            //       if (!value || value.length < 1) {
            //         cb(new Error('请至少选择一个减免范围'));
            //       } else {
            //         cb();
            //       }
            //     },
            //   },
            // ],
          },
          {
            label: '生效日期',
            prop: 'useTime',
            format: 'yyyy-MM-dd',
            valueFormat: 'yyyy-MM-dd',
            span: 12,
            type: 'date',
            clearable: false,
            disabled: true,
            rules: [
              { required: true, message: '请选择生效日期', trigger: 'blur' },
              { required: true, message: '请选择生效日期', trigger: 'change' },
            ],
          },
          {
            label: '失效日期',
            prop: 'stopTime',
            format: 'yyyy-MM-dd',
            valueFormat: 'yyyy-MM-dd',
            span: 12,
            type: 'date',
            clearable: false,
            disabled: true,
            rules: [
              { required: true, message: '请选择失效日期', trigger: 'blur' },
              {
                validator(rules, value, cb) {
                  if (self.form.stopTime <= self.form.useTime) {
                    cb(new Error('失效时间需要大于生效时间'));
                  } else {
                    cb();
                  }
                },
              },
            ],
          },
          {
            label: '减免方式',
            prop: 'sceneType',
            span: 24,
            type: 'radio',
            disabled: true,
            dicData: [
              {
                label: '预收指定期数费用',
                value: 1,
              },
              {
                label: '交清指定时间内费用',
                value: 2,
              },
              {
                label: '交满指定金额费用',
                value: 3,
              },
            ],
            rules: [{ required: true, message: '请选择减免方式', trigger: 'blur' }],
            change: ({ value, column }) => {
              self.form.sceneType = value;
              self.$refs.form1.clearValidate();
              self.$refs.form1.resetFields();
            },
          },
          {
            prop: 'form1',
            formslot: true,
            span: 24,
          },
          {
            label: '减免详情',
            prop: 'derateType',
            span: 24,
            type: 'radio',
            disabled: true,
            dicData: [
              {
                label: '指定减免期数',
                value: 1,
              },
              {
                label: '减免总额',
                value: 2,
              },
              {
                label: '赠送礼品',
                value: 3,
              },
            ],

            rules: [{ required: true, message: '请选择减免方式', trigger: 'blur' }],
            change: ({ value, column }) => {
              self.form.derateType = value;
              self.$refs.form2.clearValidate();
              self.$refs.form2.resetFields();
            },
          },
          {
            prop: 'form2',
            formslot: true,
            span: 24,
          },
          {
            label: '备注',
            span: 24,
            prop: 'description',
            type: 'textarea',
            disabled: true,
            row: true,
          },
        ],
      };
    },

    quitDialog() {
      this.$emit('close');
    },
  },
  created() {
    this.genOption();
    if (this.viewId) {
      this.pageLoading = true;
      let defaultFeeSort = this.subjectList.length > 0 ? this.subjectList[0].dictKey : '';
      getDetail({ id: this.viewId })
        .then((res) => {
          if (res.data.propertyIds == res.data.communityId) {
            res.data.propertyIdsArray = [];
          } else {
            res.data.propertyIdsArray = res.data.propertyIds.split(',');
          }
          // res.data.propertyIdsArray = res.data.propertyIds.split(',');
          res.data.scene.timeRange = [res.data.scene.startTime, res.data.scene.endTime];
          res.data.scene.subjectId = res.data.scene.subjectId
            ? res.data.scene.subjectId + ''
            : defaultFeeSort;
          res.data.derate.subjectId = res.data.derate.subjectId
            ? res.data.derate.subjectId + ''
            : defaultFeeSort;
          res.data.scene.monthType = res.data.scene.monthType ? res.data.scene.monthType + '' : '1';
          res.data.scene.includeFlag = res.data.scene.includeFlag
            ? res.data.scene.includeFlag + ''
            : '1';
          getTreeChildrenNode2({ id: res.data.communityId, useDept: 1 })
            .then((res2) => {
              this.option.column[2].dicData = res2.data;
              this.form = res.data;
              this.form1 = res.data.scene;
              this.form1.subjectId = res.data.subjectId;
              this.form2 = res.data.derate;
              this.pageLoading = false;
              this.$refs.form.form = res.data;
            })
            .catch((err) => {
              this.pageLoading = false;
            });
        })
        .catch((err) => {
          this.pageLoading = false;
        });
    }
  },
};
</script>

<style>
</style>